module.exports = __webpack_public_path__ + "static/media/car-date.f51da9bb.svg";